import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../../api/client";

async function fetchConstantData(saleAreaId) {
  const searchOptions = {
    limit: 10000000,
    page: 1,
  };

  // if (projectId){
  //   searchOptions.status = 'OPEN';
  // }
  const searchQueryParams = new URLSearchParams(searchOptions).toString();

  let searchSaleBlockQueryParams = searchQueryParams;
  if (saleAreaId)
    searchSaleBlockQueryParams =
      searchQueryParams + "&" + new URLSearchParams({ saleAreaId }).toString();

  // Fetch constant data concurrently
  const [saleBlockData, saleAreaData, branchData] = await Promise.all([
    clientAPI("get", `/saleBlock?${searchSaleBlockQueryParams}`),
    clientAPI("get", `/saleArea?${searchQueryParams}`),
    clientAPI("get", `/branch?${searchQueryParams}`),
  ]);

  // Index data by 'id' to improve lookup performance
  return {
    saleBlocks: saleBlockData?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    saleAreas: saleAreaData?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    branchs: branchData?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
  };
}

export function useCategories(saleAreaId, projectId, department) {
  // Fetch constant data once
  const {
    data: constantData,
    isLoading,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["categories22", saleAreaId, projectId, department],
    queryFn: () => fetchConstantData(saleAreaId, projectId, department),
    refetchOnWindowFocus: false,
  });

  return {
    constantData,
    isLoading,
    isFetching,
    refetch,
  };
}
